module.exports = __webpack_public_path__ + "img/9788957337059.1fa2d2ee.jpg";